import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import blogService from "../../services/blogService";

// Fallback data for when API is not available


export default function LatestBlogOne() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Format date to match expected format
  const formatDate = (dateString) => {
    if (!dateString) return "December 25, 2023";

    try {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    } catch (error) {
      return dateString;
    }
  };

  // Fetch latest blogs from API
  const fetchLatestBlogs = useCallback(async () => {
    try {
      setLoading(true);

      const params = {
        page: 1,
        limit: 3,
      };

      const response = await blogService.getAllBlogs(params);

      if (response.success && response.data && response.data.length > 0) {
        // Transform API data to match component format
        const transformedBlogs = response.data.slice(0, 3).map((blog, index) => ({
          id: blog.id,
          image: blog.image || "/assets/images/blog-1.png",
          category: blog.category || "General",
          date: formatDate(blog.created_at || blog.date),
          title: blog.title || "Untitled Blog Post",
          delay: String(index * 100),
          slug: blog.slug || `blog-${blog.id}`,
        }));

        setBlogPosts(transformedBlogs);
      }
    } catch (err) {
      console.error('Error fetching latest blogs:', err);
      setBlogPosts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch blogs on component mount
  useEffect(() => {
    fetchLatestBlogs();
  }, [fetchLatestBlogs]);

  if (!loading && blogPosts.length === 0) {
    return null;
  }

  return (
    <section id="blogs">
      <div className="blogs-section-wrapper w-full pt-16 mb-16 md:pb-[153px] overflow-hidden">
        <div className="mx-auto theme-container">
          <div className="w-full">
            <div className="flex flex-col items-center">
              <h1 className="border text-chip border-purple/30 py-0.5 px-5 rounded-[30px] w-fit mb-5">
                News & Blog
              </h1>

              <h2 className="md:text-48 text-34 font-semibold text-white mb-[60px] text-center">
                Read and explore Our latest news
              </h2>
            </div>
          </div>

          <div className="w-full grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
            {loading ? (
              <div className="col-span-full text-center py-16">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple"></div>
                <p className="text-white mt-4">Loading latest blogs...</p>
              </div>
            ) : (
              blogPosts.map((post, idx) => (
                <div
                  key={post.id}
                  data-aos="fade-left"
                  data-aos-delay={post.delay}
                  className={`item group ${idx === blogPosts.length - 1
                    ? "last:hidden xl:last:block"
                    : ""
                    }`}
                >
                  <div
                    style={{ backgroundImage: `url(${post.image})` }}
                    className="w-full h-[280px] rounded-[15px] bg-cover  bg-no-repeat relative mb-[58px]"
                  >
                    <div className="w-full absolute left-0 -bottom-7 lg:px-[50px] px-5">
                      <div className="px-[25px] py-[17px] flex justify-between items-center bg-[#160e24] w-full rounded-[10px] ">
                        <span className="font-semibold text-chip">
                          {post.category}
                        </span>
                        <div className="w-[5px] h-[5px] rounded-full bg-[#D2A98E]"></div>
                        <span className="text-paragraph">{post.date}</span>
                      </div>
                    </div>
                  </div>

                  <h2 className="text-center text-22 font-semibold mb-[35px] text-paragraph line-clamp-2 text-ellipsis overflow-hidden h-[66px]">
                    {post.title}
                  </h2>

                  <Link to={`/blog/${post.slug}`}>
                    <div className="py-5 border-t border-[#f2edff] group-hover:border-chip w-full flex justify-center common-transition">
                      <div className="flex space-x-[7px] items-center text-white group-hover:text-chip common-transition">
                        <span className="font-medium">Read More</span>
                        <span>
                          <svg
                            width="7"
                            height="11"
                            viewBox="0 0 7 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 10L4.79289 6.20711C5.12623 5.87377 5.29289 5.70711 5.29289 5.5C5.29289 5.29289 5.12623 5.12623 4.79289 4.79289L1 1"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
